import { render, staticRenderFns } from "./kpi-arc-chart.component.vue?vue&type=template&id=b72f0cc0&scoped=true"
import script from "./kpi-arc-chart.component.vue?vue&type=script&lang=ts"
export * from "./kpi-arc-chart.component.vue?vue&type=script&lang=ts"
import style0 from "./kpi-arc-chart.component.vue?vue&type=style&index=0&id=b72f0cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72f0cc0",
  null
  
)

export default component.exports